export const formSchema = {
	type: "object",
	properties: {
		name: {
			type: 'string',
			title: 'Name',
			maxLength: 64
		},
		type: {
			type: "string",
			title: "Type",
			enum: ["speed", "service", "temperature", "tamper", "stolen", "towing"],
			enumNames: ["Speed", "Service", "Temperature", "Tamper", "Stolen", "Towing"]
		}
	},
	required: ['name', 'type'],
	dependencies: {
		type: {
			oneOf: [
				{
					properties: {
						type: {
							enum: ["towing"]
						}
					},
					required: ['type']
				},
				{
					properties: {
						type: {
							enum: ["tamper"]
						}
					},
					required: ['type']
				},
				{
					properties: {
						type: {
							enum: ["stolen"]
						}
					},
					required: ['type']
				},
				{
					properties: {
						type: {
							enum: ["speed"]
						},
						value: {
							type: 'number',
							title: 'Max Speed (KMs/h)'
						}
					},
					required: ['type', 'value']
				},
				{
					properties: {
						type: {
							enum: ["service"]
						},
						value: {
							type: 'number',
							title: 'Service every Kms'
						}
					},
					required: ['type', 'value']
				},
				{
					properties: {
						type: {
							enum: ["temperature"]
						},
						value: {
							type: 'number',
							title: 'Lower Range (Celsius)'
						},
						value2: {
							type: 'number',
							title: 'Upper Range (Celsius)'
						}
					},
					required: ['type', 'value', 'value2']
				},
			]
		}
	}
};

export const uiSchema = {
	title: {
		"ui:autofocus": true,
	},
	mobile: {
		"ui:widget": "updown",
	},
	email: {
		"ui:validations": {
			pattern: {
				value: "[a-zA-Z]{1}[a-zA-Z\\-\\+_]@[a-zA-Z\\-_]+\\.com",
				message: "Please enter valid email",
				inline: true
			}
		}
	}
};
